import type {
  DeployCommandLine,
  LineDeployCommandProps
} from "./deployment-command.types"

export const DEFAULT_END_LINE = " \\\n"

export const getTextForValue = (value: string, defaultValue: string) =>
  value === defaultValue ? `[${value}]` : value

export const getAlign = (align: LineDeployCommandProps["align"]) => {
  if (align === "space-between") return " "

  return ""
}

export const getLineDeployCommand = (props: LineDeployCommandProps) => {
  const { value, defaultValue, align, suffix = "" } = props
  const currentValue =
    value !== undefined && defaultValue !== undefined
      ? `${getTextForValue(value, defaultValue)}`
      : ""

  return `${props.text}${getAlign(align)}${currentValue}${suffix}`
}

export const getDeployCommandString = (
  props: {
    lines: Record<string, DeployCommandLine>
    values: Record<string, string>
    defaultValues: Record<string, string>
  },
  keys?: (number | string)[]
) => {
  try {
    const data = Array.isArray(keys)
      ? keys
      : new Array(Object.keys(props.lines).length).fill(undefined)

    return data
      .map((value, index) => {
        try {
          const key = !value ? (index + 1).toString() : value
          const { text, name, align, suffix } = props.lines[key]

          return getLineDeployCommand({
            text,
            align,
            value: name && props.values[name],
            defaultValue: name && props.defaultValues[name],
            firstLine: index === 0,
            suffix
          })
        } catch (error) {
          console.error(error)

          return ""
        }
      })
      .filter((v) => !!v)
      .join(DEFAULT_END_LINE)
  } catch (error) {
    console.error(error)

    return ""
  }
}

// A multi-command script: the lines of a group (one shell command) are joined
// with " \", the groups with a newline (e.g. VAR="..." lines, # comments and
// CLI commands).
export const getScriptDeployCommandString = (props: {
  lines: Record<string, DeployCommandLine>
  groups: string[][]
  values: Record<string, string>
  defaultValues: Record<string, string>
}) => {
  const { groups, ...rest } = props

  return groups.map((keys) => getDeployCommandString(rest, keys)).join("\n")
}

// A shell variable assignment with an inline input: NAME="<value>"
export const getShellVariableLine = (
  variable: string,
  name: string
): DeployCommandLine => ({ text: `${variable}="`, name, suffix: '"' })
